var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.loopkey,
      ref: "move-box",
      class: {
        "widgets-wrap": true,
        maxTop: _vm.isFocus || !!_vm.cachetMove || _vm.showSetting,
        move: !!_vm.cachetMove,
        fixed: !!_vm.itemInfo.chapteFixed
      },
      style: [_vm.handleSetChapte, _vm.styleIconVar],
      attrs: { tabindex: "0" },
      on: {
        "!click": function($event) {
          return _vm.$emit("click", _vm.itemInfo)
        }
      }
    },
    [
      !_vm.itemInfo.chapteFixed
        ? [
            _c(
              "div",
              { staticClass: "input-wrap" },
              [
                _c("span", {
                  staticClass: "icon-drag",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.handleCacheMousedown($event)
                    }
                  }
                }),
                _c("span", {
                  staticClass: "el-icon-error delco",
                  on: { click: _vm.delItemInfo }
                }),
                _vm.itemInfo.varType === _vm.flag.MULTITEXT
                  ? [
                      _c("el-input", {
                        ref: "inputbox",
                        class: [
                          ["", "text_align_center", "text_align_right"][
                            Number(_vm.itemInfo.align)
                          ],
                          {
                            "copy-sty-input": _vm.itemInfo.copy,
                            font_bold: _vm.itemInfo.bold
                          }
                        ],
                        style: _vm.SetWh,
                        attrs: {
                          type: "textarea",
                          value: _vm.itemInfo.varName,
                          readonly: _vm.itemInfo.copy,
                          placeholder:
                            _vm.getFlagInfo.text + (parseInt(_vm.loopkey) + 1),
                          maxlength: "20",
                          resize: "none",
                          autosize: ""
                        },
                        on: {
                          input: _vm.changeVarName,
                          focus: function($event) {
                            return _vm.handleVartable(true)
                          },
                          blur: function($event) {
                            _vm.isFocus = false
                          }
                        }
                      }),
                      _vm.isFocus
                        ? [
                            _c("span", {
                              staticClass: "tl",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "tl")
                                }
                              }
                            }),
                            _c("span", {
                              staticClass: "bl",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "bl")
                                }
                              }
                            }),
                            _c("span", {
                              staticClass: "tr",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "tr")
                                }
                              }
                            }),
                            _c("span", {
                              staticClass: "r",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "r")
                                }
                              }
                            }),
                            _c("span", {
                              staticClass: "br",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "br")
                                }
                              }
                            })
                          ]
                        : _vm._e()
                    ]
                  : _vm.itemInfo.varType === _vm.flag.RADIO
                  ? _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleVartable(true)
                          }
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            ref: "inputbox",
                            staticClass: "check-sty",
                            class: { "copy-sty": _vm.itemInfo.copy },
                            style: _vm.SetWh,
                            model: {
                              value: _vm.radioCheck,
                              callback: function($$v) {
                                _vm.radioCheck = $$v
                              },
                              expression: "radioCheck"
                            }
                          },
                          [
                            _vm._l(_vm.optionList, function(vv, i) {
                              return _c(
                                "p",
                                {
                                  key: i,
                                  style: {
                                    "text-align": ["left", "center", "right"][
                                      Number(_vm.itemInfo.align)
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "check-icon",
                                      attrs: { label: vv.key }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            "font-size":
                                              _vm.itemInfo.fontSize + "px",
                                            "line-height":
                                              "" + _vm.checkLineHeight,
                                            "font-weight": _vm.itemInfo.bold
                                              ? "bold"
                                              : ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(vv.val || vv.placeholder) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm.isFocus
                              ? [
                                  _c("span", {
                                    staticClass: "tl",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "tl"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "bl",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "bl"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "tr",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "tr"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "r",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "r"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "br",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "br"
                                        )
                                      }
                                    }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm.itemInfo.varType === _vm.flag.MULTIPLE
                  ? _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleVartable(true)
                          }
                        }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            ref: "inputbox",
                            staticClass: "check-sty",
                            class: { "copy-sty": _vm.itemInfo.copy },
                            style: _vm.SetWh,
                            model: {
                              value: _vm.checkList,
                              callback: function($$v) {
                                _vm.checkList = $$v
                              },
                              expression: "checkList"
                            }
                          },
                          [
                            _vm._l(_vm.optionList, function(vv, i) {
                              return _c(
                                "p",
                                {
                                  key: i,
                                  style: {
                                    "text-align": ["left", "center", "right"][
                                      Number(_vm.itemInfo.align)
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "check-icon",
                                      attrs: { label: vv.key }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            "font-size":
                                              _vm.itemInfo.fontSize + "px",
                                            "line-height":
                                              "" + _vm.checkLineHeight,
                                            "font-weight": _vm.itemInfo.bold
                                              ? "bold"
                                              : ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(vv.val || vv.placeholder) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm.isFocus
                              ? [
                                  _c("span", {
                                    staticClass: "tl",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "tl"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "bl",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "bl"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "tr",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "tr"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "r",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "r"
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", {
                                    staticClass: "br",
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                        return _vm.sfMousedownHanlder(
                                          $event,
                                          "br"
                                        )
                                      }
                                    }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : [
                      _c("el-input", {
                        ref: "inputbox",
                        class: [
                          ["", "text_align_center", "text_align_right"][
                            Number(_vm.itemInfo.align)
                          ],
                          {
                            "copy-sty-input": _vm.itemInfo.copy,
                            font_bold: _vm.itemInfo.bold
                          }
                        ],
                        style: _vm.SetWh,
                        attrs: {
                          type: "text",
                          value: _vm.itemInfo.varName,
                          placeholder: _vm.getFlagInfo.text + _vm.order,
                          maxlength: "20",
                          readonly:
                            !_vm.getFlagInfo.isFormat || _vm.itemInfo.copy
                        },
                        on: {
                          input: _vm.changeVarName,
                          focus: function($event) {
                            return _vm.handleVartable(true)
                          },
                          blur: function($event) {
                            _vm.isFocus = false
                          }
                        }
                      }),
                      _vm.isFocus
                        ? [
                            _c("span", {
                              staticClass: "r",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.sfMousedownHanlder($event, "r")
                                }
                              }
                            })
                          ]
                        : _vm._e()
                    ]
              ],
              2
            ),
            _vm.showSetting
              ? _c(
                  "div",
                  {
                    ref: "settingBox",
                    staticClass: "set-wrap",
                    style: _vm.settingStyle()
                  },
                  [
                    _c("h1", [
                      _vm._v("\n          设置变量"),
                      _c("span", {
                        staticClass: "el-icon-error",
                        on: {
                          click: function($event) {
                            return _vm.changeShowSetting(false)
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "con" },
                      [
                        _c("p", { staticClass: "var-setting" }, [
                          _vm._v("变量名称")
                        ]),
                        _c("el-input", {
                          attrs: {
                            value: _vm.itemInfo.inputId,
                            placeholder: "填写变量名称",
                            disabled: _vm.itemInfo.copy,
                            maxlength: "20",
                            type: "text",
                            resize: "none",
                            row: 2
                          },
                          on: { input: _vm.changeInputId }
                        }),
                        _c("p", { staticClass: "var-setting" }, [
                          _vm._v("变量类型")
                        ]),
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择变量类型",
                                disabled: _vm.itemInfo.copy
                              },
                              on: { change: _vm.changeVarType },
                              model: {
                                value: _vm.itemInfo.varType,
                                callback: function($$v) {
                                  _vm.$set(_vm.itemInfo, "varType", $$v)
                                },
                                expression: "itemInfo.varType"
                              }
                            },
                            _vm._l(_vm.flagType.flagOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        _vm.itemInfo.varType === _vm.flag.SYSTEMDATE
                          ? [
                              _c("p", { staticClass: "var-setting" }, [
                                _vm._v("日期格式")
                              ]),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择日期格式",
                                    disabled: _vm.itemInfo.copy
                                  },
                                  model: {
                                    value: _vm.itemInfo.formatStyle,
                                    callback: function($$v) {
                                      _vm.$set(_vm.itemInfo, "formatStyle", $$v)
                                    },
                                    expression: "itemInfo.formatStyle"
                                  }
                                },
                                _vm._l(_vm.flagType.systemDateOptions, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("p", { staticClass: "var-setting" }, [
                                _vm._v("对应签章")
                              ]),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择签章",
                                    disabled: _vm.itemInfo.copy
                                  },
                                  model: {
                                    value: _vm.itemInfo.signerAbc,
                                    callback: function($$v) {
                                      _vm.$set(_vm.itemInfo, "signerAbc", $$v)
                                    },
                                    expression: "itemInfo.signerAbc"
                                  }
                                },
                                [
                                  _vm._l(_vm.signerList, function(
                                    signerItem,
                                    signerIndex
                                  ) {
                                    return [
                                      signerItem.fix == 0
                                        ? _c("el-option", {
                                            key: signerIndex,
                                            attrs: {
                                              label: signerItem.signerAbc,
                                              value: signerItem.signerAbc
                                            }
                                          })
                                        : _c("el-option", {
                                            key: signerIndex,
                                            attrs: {
                                              label: signerItem.name,
                                              value: signerItem.signerAbc
                                            }
                                          })
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e(),
                        _vm.getFlagInfo.isFormat &&
                        _vm.itemInfo.varType !== _vm.flag.RADIO &&
                          _vm.itemInfo.varType !== _vm.flag.MULTIPLE &&
                          _vm.itemInfo.varType !== _vm.flag.SYSTEMDATE
                          ? [
                              _c("p", { staticClass: "var-setting" }, [
                                _vm._v("提示文字")
                              ]),
                              _vm.itemInfo.varType === _vm.flag.MULTITEXT
                                ? [
                                    _c("el-input", {
                                      class: [
                                        [
                                          "",
                                          "text_align_center",
                                          "text_align_right"
                                        ][Number(_vm.itemInfo.align)],
                                        { font_bold: _vm.itemInfo.bold }
                                      ],
                                      attrs: {
                                        value: _vm.itemInfo.varName,
                                        placeholder:
                                          _vm.getFlagInfo.text + _vm.order,
                                        maxlength: "20",
                                        type: _vm.getFlagInfo.type,
                                        resize: "none",
                                        row: 2,
                                        disabled: _vm.itemInfo.copy
                                      },
                                      on: { input: _vm.changeVarName }
                                    })
                                  ]
                                : [
                                    _c("el-input", {
                                      class: [
                                        [
                                          "",
                                          "text_align_center",
                                          "text_align_right"
                                        ][Number(_vm.itemInfo.align)],
                                        { font_bold: _vm.itemInfo.bold }
                                      ],
                                      attrs: {
                                        value: _vm.itemInfo.varName,
                                        placeholder: _vm.getFlagInfo.text,
                                        type: _vm.getFlagInfo.type,
                                        maxlength: "20",
                                        disabled: _vm.itemInfo.copy
                                      },
                                      on: { input: _vm.changeVarName }
                                    })
                                  ]
                            ]
                          : _vm._e(),
                        _vm.itemInfo.varType === _vm.flag.RADIO ||
                        _vm.itemInfo.varType === _vm.flag.MULTIPLE
                          ? [
                              _c("p", { staticClass: "var-setting between" }, [
                                _c("span", [_vm._v("选项设置")]),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.itemInfo.copy,
                                      expression: "!itemInfo.copy"
                                    }
                                  ],
                                  staticClass:
                                    "el-icon-circle-plus-outline action-sty",
                                  on: { click: _vm.addOption }
                                })
                              ]),
                              _vm._l(_vm.optionList, function(vv, i) {
                                return _c(
                                  "p",
                                  { key: vv.key, staticClass: "option-item" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-s-operation"
                                    }),
                                    _c("el-input", {
                                      staticStyle: { margin: "0 5px" },
                                      attrs: {
                                        type: "text",
                                        placeholder: vv.placeholder,
                                        disabled: _vm.itemInfo.copy,
                                        maxlength: 20,
                                        clearable: ""
                                      },
                                      model: {
                                        value: vv.val,
                                        callback: function($$v) {
                                          _vm.$set(vv, "val", $$v)
                                        },
                                        expression: "vv.val"
                                      }
                                    }),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.itemInfo.copy,
                                          expression: "!itemInfo.copy"
                                        }
                                      ],
                                      staticClass: "el-icon-delete action-sty",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeOption(i)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              })
                            ]
                          : _vm._e(),
                        _c("p", { staticClass: "var-setting" }, [
                          _vm._v("字号")
                        ]),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: _vm.itemInfo.fontSize,
                              placeholder: "请选择",
                              disabled: _vm.itemInfo.copy
                            },
                            on: { change: _vm.changeFontSize }
                          },
                          _vm._l(_vm.fontOptions, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "15px" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  value: _vm.itemInfo.varIsMust,
                                  disabled: _vm.itemInfo.copy
                                },
                                on: {
                                  change: function(val) {
                                    _vm.$emit(
                                      "changeItemInfo",
                                      Object.assign({}, this$1.itemInfo, {
                                        varIsMust: val
                                      })
                                    )
                                  }
                                }
                              },
                              [_vm._v("必填\n            ")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  value: _vm.itemInfo.bold,
                                  "true-label": 1,
                                  "false-label": "",
                                  disabled: _vm.itemInfo.copy
                                },
                                on: {
                                  change: function(val) {
                                    _vm.$emit(
                                      "changeItemInfo",
                                      Object.assign({}, this$1.itemInfo, {
                                        bold: val
                                      })
                                    )
                                  }
                                }
                              },
                              [_vm._v("加粗\n            ")]
                            ),
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { "margin-top": "10px" },
                                model: {
                                  value: _vm.itemInfo.align,
                                  callback: function($$v) {
                                    _vm.$set(_vm.itemInfo, "align", $$v)
                                  },
                                  expression: "itemInfo.align"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: "" } }, [
                                  _vm._v("左对齐")
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("居中")
                                ]),
                                _c("br"),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("右对齐")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.getFlagInfo.isFormat &&
                        _vm.itemInfo.varType !== _vm.flag.SYSTEMDATE
                          ? _c("p", { staticStyle: { "margin-top": "15px" } }, [
                              _vm._v(
                                "\n            可输入字数：" +
                                  _vm._s(_vm.itemInfo.fontMaxNum) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.itemInfo.copy,
                            expression: "!itemInfo.copy"
                          }
                        ],
                        staticClass: "btns-sty"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn",
                            on: { click: _vm.copyShowSetting }
                          },
                          [_vm._v("复制")]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "btn",
                            on: {
                              click: function($event) {
                                return _vm.changeShowSetting(false)
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        : _c(
            "div",
            { staticClass: "fixedWt" },
            [
              _vm.itemInfo.varType === _vm.flag.MULTITEXT
                ? [
                    _c("el-input", {
                      class: [
                        ["", "text_align_center", "text_align_right"][
                          Number(_vm.itemInfo.align)
                        ],
                        {
                          font_bold: _vm.itemInfo.bold,
                          outstanding: !!_vm.itemInfo.selected,
                          "copy-sty-input": _vm.itemInfo.copy
                        }
                      ],
                      style: _vm.SetWh,
                      attrs: {
                        type: "textarea",
                        value: _vm.itemInfo.value,
                        readonly: _vm.itemInfo.copy,
                        maxlength: _vm.itemInfo.fontMaxNum,
                        placeholder:
                          _vm.itemInfo.varName || _vm.getFlagOption.title,
                        resize: "none"
                      },
                      on: { input: _vm.changeValue }
                    })
                  ]
                : _vm.itemInfo.varType === _vm.flag.DATE
                ? [
                    _c("el-date-picker", {
                      class: [
                        ["", "text_align_center", "text_align_right"][
                          Number(_vm.itemInfo.align)
                        ],
                        {
                          outstanding: !!_vm.itemInfo.selected,
                          "copy-sty-input": _vm.itemInfo.copy,
                          font_bold: _vm.itemInfo.bold
                        }
                      ],
                      style: _vm.SetWh,
                      attrs: {
                        type: "date",
                        align: "left",
                        "value-format": "yyyy-MM-dd",
                        value: _vm.itemInfo.value,
                        editable: false,
                        disabled: _vm.itemInfo.copy,
                        placeholder:
                          _vm.itemInfo.varName || _vm.getFlagOption.title
                      },
                      on: { input: _vm.changeValue }
                    })
                  ]
                : _vm.itemInfo.varType === _vm.flag.RADIO
                ? [
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "check-sty",
                        class: { "copy-sty": _vm.itemInfo.copy },
                        style: _vm.SetWh,
                        attrs: {
                          value: _vm.itemInfo.value,
                          disabled: _vm.itemInfo.copy
                        },
                        on: { input: _vm.changeValue }
                      },
                      _vm._l(_vm.optionList, function(vv, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "item-check",
                            style: {
                              "text-align": ["left", "center", "right"][
                                Number(_vm.itemInfo.align)
                              ]
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                staticClass: "check-icon",
                                attrs: { label: vv.val }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      "font-size": _vm.itemInfo.fontSize + "px",
                                      "line-height": "" + _vm.checkLineHeight,
                                      "font-weight": _vm.itemInfo.bold
                                        ? "bold"
                                        : ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(vv.val || vv.placeholder) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                : _vm.itemInfo.varType === _vm.flag.MULTIPLE
                ? [
                    _c(
                      "el-checkbox-group",
                      {
                        staticClass: "check-sty",
                        class: { "copy-sty": _vm.itemInfo.copy },
                        style: _vm.SetWh,
                        attrs: {
                          value: _vm.itemInfo.value,
                          disabled: _vm.itemInfo.copy
                        },
                        on: { change: _vm.changeValue }
                      },
                      _vm._l(_vm.optionList, function(vv, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "item-check",
                            style: {
                              "text-align": ["left", "center", "right"][
                                Number(_vm.itemInfo.align)
                              ]
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticClass: "check-icon",
                                attrs: { label: vv.val }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      "font-size": _vm.itemInfo.fontSize + "px",
                                      "line-height": "" + _vm.checkLineHeight,
                                      "font-weight": _vm.itemInfo.bold
                                        ? "bold"
                                        : ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(vv.val || vv.placeholder) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                : [
                    _c("el-input", {
                      class: [
                        ["", "text_align_center", "text_align_right"][
                          Number(_vm.itemInfo.align)
                        ],
                        {
                          outstanding: !!_vm.itemInfo.selected,
                          "copy-sty-input": _vm.itemInfo.copy,
                          font_bold: _vm.itemInfo.bold
                        }
                      ],
                      style: _vm.SetWh,
                      attrs: {
                        type: "text",
                        value: _vm.itemInfo.value,
                        readonly:
                          _vm.itemInfo.copy ||
                          Number(_vm.itemInfo.varType) ===
                            Number(_vm.flag.SYSTEMDATE),
                        placeholder:
                          _vm.itemInfo.varName || _vm.getFlagOption.title,
                        maxlength: _vm.itemInfo.fontMaxNum
                      },
                      on: { input: _vm.changeValue }
                    })
                  ]
            ],
            2
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15e1638b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e1638b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/advancedVersion/widgets.vue
// module id = efrw
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25